
import { Vue, Component, Prop } from "vue-property-decorator";
import storage from "@/services/storage";

@Component
export default class PageHeadAvatar extends Vue {
  @Prop({type: String, default: undefined}) readonly s3FileKey?: string;
  @Prop(String) readonly initial!: string;

  filepath: string | null = null;

  async mounted() {
    if (!this.s3FileKey) {
      return;
    }
    await this.loadImage();
  }

  async updated() {
    if (!this.s3FileKey) {
      return;
    }
    await this.loadImage();
  }

  async loadImage() {
    if (this.s3FileKey) {
      this.filepath = await storage.get(this.s3FileKey);
    }
  }
}
